import PortalIdParser from 'PortalIdParser';
export const getUserContactPageUrl = (userId, portalId = PortalIdParser.getPortalIdFromPath()) => {
  return `/settings/${portalId}/users/user/${userId}`;
};